import { render, staticRenderFns } from "./MiPerfil.vue?vue&type=template&id=e9d101be&scoped=true&"
import script from "./MiPerfil.vue?vue&type=script&lang=ts&"
export * from "./MiPerfil.vue?vue&type=script&lang=ts&"
import style0 from "./MiPerfil.vue?vue&type=style&index=0&id=e9d101be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d101be",
  null
  
)

export default component.exports